import React from 'react'
import clsx from 'clsx'

// Cube
import { classToFComponent, type FCClassContext } from 'cube-react'

// Gov-br
import {
    Col,
    Row,
    BrButton,
    BrInput,
    type BrInputProps,
    BrSelect,
    type BrSelectProps,
    BrDateTimePicker,
    type BrDateTimePickerProps
} from '@govbr-ds/react-components'

import Sel from './styles-consts'
import Icons from '@/shared/AppIcons'

import { FiltroScope } from '../analise-reacoes.scope'

const styles = {
    lblFilter1: { alignItems: 'center' },
    lblFilter2: { marginLeft: '5pt' },
    pnlActions: { padding: '10px' },
    btnLimpar: { alignSelf: 'baseline', marginTop: '8pt' },
    btnBuscar: { alignSelf: 'baseline', marginTop: '8pt' },
    inpPeriodo: { alignSelf: 'stretch', flexGrow: 1 },

    flexCenteredLayout: { display: 'flex', alignItems: 'center' },
    flexGrow: { flexGrow: 1 }
} satisfies Record<string, React.CSSProperties>

export type FiltroProps = {
    className?: string
    scope: FiltroScope
}

class FiltroViewClass implements FCClassContext<FiltroProps> {
    scope!: FiltroScope

    // :: Listener adapters

    onBuscaGeralTextChanged: BrInputProps['onChange'] = (e) => {
        this.scope.onBuscaGeralTextChanged(e.target.value)
    }

    onBuscaReacaoTextChanged: BrInputProps['onChange'] = (e) => {
        this.scope.onBuscaReacaoTextChanged(e.target.value)
    }

    onBuscaMedicamentoChanged: BrInputProps['onChange'] = (e) => {
        this.scope.onBuscaMedicamentoChanged(e.target.value)
    }

    onStatusBulaChanged: BrSelectProps<number>['onChange'] = (value) => {
        this.scope.onStatusBulaChanged(value)
    }

    onGravidadeChanged: BrSelectProps<number>['onChange'] = (value) => {
        this.scope.onGravidadeChanged(value)
    }

    onPeriodoChange: BrDateTimePickerProps['onRangeChange'] = (range) => {
        this.scope.onPeriodoChange(range)
    }

    render({ className, scope }: FiltroProps) {
        this.scope = scope

        return (
            <Row className={clsx(className)}>
                <Col>
                    <div className={Sel.brCard}>
                        <div className={Sel.brCardContent}>
                            <div
                                className={clsx(Sel.textUp02, Sel.textWeightSemiBold, Sel.dFlexV)}
                                style={styles.lblFilter1}
                            >
                                <img width={20} height={20} src={Icons.filterIconUrl} />
                                <span style={styles.lblFilter2}>Filtros Avançados de Análise</span>
                            </div>
                            <br />
                            <Row className={Sel.flexColumnGapBase}>
                                <Col>
                                    <BrInput
                                        label="Buscar Geral"
                                        placeholder="Medicamento, ATC, paciente..."
                                        value={scope.buscaGeralText}
                                        onChange={this.onBuscaGeralTextChanged}
                                    />
                                </Col>
                                <Col>
                                    <BrInput
                                        label="Buscar Reação (MedDRA)"
                                        placeholder="PT, LLT ou nome da reação..."
                                        value={scope.buscaReacaoText}
                                        onChange={this.onBuscaReacaoTextChanged}
                                    />
                                </Col>
                                <Col>
                                    <BrInput
                                        label="Medicamento (WHO Drug)"
                                        placeholder="Nome ou princípio ativo..."
                                        value={scope.buscaMedicamentoText}
                                        onChange={this.onBuscaMedicamentoChanged}
                                    />
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col>
                                    <Row>
                                        <BrSelect
                                            className={Sel.colMd}
                                            label="Status bula"
                                            placeholder="Selecione o Status"
                                            type="single"
                                            value={scope.statusBula}
                                            options={scope.statusBulaOptions}
                                            onChange={this.onStatusBulaChanged}
                                        />
                                    </Row>
                                </Col>
                                <Col>
                                    <Row>
                                        <BrSelect
                                            className={Sel.colMd}
                                            label="Gravidade"
                                            placeholder="Selecione uma gravidade"
                                            type="single"
                                            value={scope.gravidade}
                                            options={scope.gravidadeOptions}
                                            onChange={this.onGravidadeChanged}
                                        />
                                    </Row>
                                </Col>
                                <Col>
                                    <BrDateTimePicker
                                        label="Período"
                                        dataMode="range"
                                        dataType="date"
                                        placeholder="exemplo: 01/02/2025 até 03/02/2025"
                                        style={styles.inpPeriodo}
                                        value={scope.periodo}
                                        onRangeChange={this.onPeriodoChange}
                                    />
                                </Col>
                            </Row>
                            <div className={clsx(Sel.dFlexV, Sel.flexColumnGapBase)}>
                                <div style={styles.flexGrow}>&nbsp;</div>
                                <BrButton secondary style={styles.btnLimpar} onClick={scope.onLimpar}>
                                    Limpar filtros
                                </BrButton>
                                <BrButton primary style={styles.btnBuscar} onClick={scope.onConsultar}>
                                    Buscar
                                </BrButton>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        )
    }
}

export default classToFComponent(FiltroViewClass)
